import { AppliedCouponResponse } from "@9amhealth/openapi";
import React, { useMemo } from "react";
import Price from "../Price/Price";

interface CouponDiscountProps {
  coupon: AppliedCouponResponse;
  totalPrice: number;
}

const CouponDiscount = ({ coupon, totalPrice }: CouponDiscountProps) => {
  const absDiscount = useMemo(() => {
    if (coupon.discountFactor) {
      return totalPrice * coupon.discountFactor;
    }
    return coupon.amountOff;
  }, [coupon.discountFactor, coupon.amountOff, totalPrice]);

  if (!absDiscount) {
    return null;
  }

  return (
    <>
      <Price amount={absDiscount} formatLocale prefix="-" />
    </>
  );
};

export default CouponDiscount;
